// extracted by mini-css-extract-plugin
export default {"heading":"vw-z","corrected":"ww-z","redirectVerbiageContainer":"xw-z","redirectVerbiageText":"yw-z"};